import React, { PropsWithChildren } from 'react';
import Link, { LinkProps } from '@material-ui/core/Link';
import withThemeProvider from '../util/withThemeProvider';

const SolvLink = ({ children, ...rest }: PropsWithChildren<LinkProps>) => (
  <Link {...rest}>{children}</Link>
);

export default withThemeProvider(SolvLink);
